import Alert from '@mui/material/Alert';
import Fade from '@mui/material/Fade';
import { AlertTitle, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

function ToastMessage() {
  const { t } = useTranslation();

  return (
    <Box textAlign="left">
      <Fade in appear>
        <Alert severity="success">
          <AlertTitle><b>{t('alertMessage.title')}</b></AlertTitle>
          {t('alertMessage.body')}
        </Alert>
      </Fade>
    </Box>
  )
}

export default ToastMessage;